    <mat-form-field appearance="outline" class="SearchInput">
      <mat-label>Item # Search</mat-label>
      @if (!isRetailerOnlyMode()) {
        <input #searchInput matInput [ngModel]="skuToShow()" (ngModelChange)="inputModelChange($event)" (keypress)="inputKeyPress($event)" (keydown)="inputKeyDown($event)" (keyup)="inputKeyUp($event)">
      } @else {
        <input matInput [ngModel]="skuToShow()" (ngModelChange)="skuToShow.set($event.trim())" (change)="searchSKU(skuToShow().trim())">
      }
      <button mat-button matTextSuffix class="ThemeColorPrimary" (click)="closeSearch.emit()">Close</button>
    </mat-form-field>
    @if (searchResults().length > 0) {
      <div class="SearchResultsContainer">
        <ul #searchResultsContainer class="SearchResults">
          @for (result of searchResults(); let i = $index; track $index) {
            <li #searchResult class="SearchResult" [class.Selected]="selectedIndex() === i">
              <a href="#" (click)="$event.preventDefault(); resultSelected(result)">
                <span class="ItemNumber">{{ result.itemNumberOrStyle }}</span>
                @if (result.itemDescription) {
                  <span class="ItemDescription">({{ result.itemDescription }})</span>
                }
              </a>
            </li>
          }
        </ul>
      </div>
    }